import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import React from 'react';
import Button from '../../Button';
import { SearchIcon } from '../../../../../assets';

type SearchInputProps = Omit<TextFieldProps, 'variant'>;
export function SearchInput(props: SearchInputProps) {
  const { InputProps, onChange, value, ...restProps } = props;
  const inputRef = React.useRef<HTMLInputElement>(null);
  const hasValue = typeof value === 'string' && value.length > 0;
  const onClickButton = (e: any) => {
    inputRef.current?.focus();
    props.onClick && props.onClick(e);
  };
  const onClickClear = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onChange &&
      onChange({
        ...e,
        target: { ...(e.target as any), value: '' },
      } as unknown as React.ChangeEvent<HTMLInputElement>);
    inputRef.current?.focus();
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <TextField
        fullWidth
        placeholder="Write to start search"
        variant="outlined"
        sx={(theme) => ({
          '& .MuiOutlinedInput-root': {
            // Dark background
            backgroundColor: theme.palette.background.paper,

            // White text
            color: theme.palette.common.black,

            // Rounded left corners only
            borderRadius: '8px 0 0 8px',

            // Gray border
            fieldset: { borderColor: '#555' },

            ...theme.applyStyles('dark', {
              color: theme.palette.common.white,
            }),
          },

          '& .MuiOutlinedInput-input': {
            height: '1.5rem',
            padding: 2,
          },
        })}
        inputRef={inputRef}
        value={value}
        onChange={onChange}
        {...restProps}
        InputProps={{
          ...InputProps,
          endAdornment: (
            <>
              {hasValue && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    edge="end"
                    aria-label="clear search"
                    onClick={onClickClear}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )}
              {InputProps?.endAdornment}
            </>
          ),
        }}
      />
      <Button
        variant="contained"
        sx={{
          borderRadius: '0 8px 8px 0', // Rounded right corners
          padding: 2,
          width: '7rem',
          fontSize: '1.5rem',
          height: '1.5rem',
          boxSizing: 'content-box',
        }}
        onClick={onClickButton}
      >
        <SearchIcon />
      </Button>
    </div>
  );
}

export default SearchInput;
